import { render, staticRenderFns } from "./optionalfeespayments.vue?vue&type=template&id=b4e52782&"
import script from "./optionalfeespayments.vue?vue&type=script&lang=js&"
export * from "./optionalfeespayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports